import CommonFaqView from "src/components/faq/CommonFaqView";

const CommonFaqPage = () => {
  return <CommonFaqView />;
};

export default CommonFaqPage;
